<script lang="ts">
	import { cva, type VariantProps } from "class-variance-authority";
	import { twMerge } from "tailwind-merge";
	import { DEFAULT_VARIANTS } from "../utils";
	import type { Snippet } from "svelte";

	const cardProps = cva(["card", "cursor-auto", "duration-300", "rounded-base", "shadow-lg", "transition-all"], {
		defaultVariants: {
			variant: "default"
		},
		variants: {
			variant: {
				...DEFAULT_VARIANTS,
				fifth: ["fifth"],
				fourth: ["fourth"],
				third: ["!bg-base-300"],
				secondary: ["!bg-base-200"]
			}
		}
	});
	type CardProps = VariantProps<typeof cardProps>;
	interface Props {
		style?: string | undefined;
		variant?: CardProps["variant"];
		class?: string | undefined;
		header?: Snippet;
		children?: Snippet;
		[key: string]: any;
	}

	let {
		style = undefined,
		variant = undefined,
		class: className = undefined,
		header,
		children,
		...rest
	}: Props = $props();
</script>

<div class={twMerge(cardProps({ variant }), className)} style={style} role="button" tabindex="0" {...rest}>
	{@render header?.()}
	{@render children?.()}
</div>
